export default __webpack_public_path__ + "static/media/Hokky.06cc0504.png";